import React from 'react'
import './CreditsSection.css'

const CreditsSection = (props) => {
    return (
        <div className="credits-section">
            <p>Performance: <span dangerouslySetInnerHTML={{ __html: props.formatSectionHeaderStr(props.Data.credits) }}></span></p>
            <p>Content Author: <span dangerouslySetInnerHTML={{ __html: props.formatSectionHeaderStr(props.Data.authorcredits) }}></span></p>
        </div>
    )
}

export default CreditsSection